import axios from 'axios';
import { API_ENDPOINT } from './utils/Constants';

const Axios = axios.create({ baseURL: API_ENDPOINT });

export const saveOperators = (body: any) => Axios.post('Operators', body);
export const savePoseAreas = (body: any) => Axios.post('PoseAreas', body);
export const saveBodyAreas = (body: any) => Axios.post('BodyAreas', body);
export const saveJobs = (body: any) => Axios.post('jobs', body);
export const saveTasks = (body: any) => Axios.post('tasks', body);
export const saveTasksets = (body: any) => Axios.post('tasksets', body);


export const getPoseAreas = (body: any) => Axios.get('PoseAreas', body);
export const getBodyAreas = (body: any) => Axios.get('BodyAreas', body);
export const getJobs = (body: any) => Axios.get('jobs', body);
export const getTasks = (body: any) => Axios.get('tasks', body);
export const getTasksets = (body: any) => Axios.get('tasksets', body);
